import styles from '../../article.module.css';

import { Timeline, Tweet } from 'react-twitter-widgets';

export const VirtualTwitter = (props: TwitterProps) => {
	const { type } = props;
	if (type === 'tweet') {
		return <VirtualTweet {...props} />;
	}
	return <VirtualTwitterTimeline {...props} />;
};

const VirtualTweet = (props: TwitterProps) => {
	const { id, bleed, height, fixedHeight, tweetid } = props;
	const containerStyle: any = {};

	if (fixedHeight && height) {
		containerStyle.height = height;
		containerStyle.minHeight = height;
		containerStyle.maxHeight = height;
	}

	const className = [styles['twitter'], 'media', styles['tweet']];
	if (bleed) {
		className.push('bleed');
	}

	return (
		<div id={id} style={containerStyle} className={className.join(' ')}>
			<Tweet tweetId={`${tweetid}`} />
		</div>
	);
};

export const VirtualTwitterTimeline = (props: TwitterProps) => {
	const { id, name, bleed, height, fixedHeight } = props;
	const containerStyle: any = {};

	if (fixedHeight && height) {
		containerStyle.height = height;
		containerStyle.minHeight = height;
		containerStyle.maxHeight = height;
	}

	const className = [styles['twitter'], 'media'];
	if (bleed) {
		className.push('bleed');
	}

	return (
		<div id={id} style={containerStyle} className={className.join(' ')}>
			<Timeline
				dataSource={{
					sourceType: 'profile',
					screenName: name,
				}}
				options={{
					height: '100%',
				}}
			/>
		</div>
	);
};

interface TwitterProps {
	id: string;
	name: string;
	bleed: boolean;
	height: number;
	fixedHeight: boolean;
	tweetid?: string;
	type: string;
}
